import React from 'react'
import { observer } from 'mobx-react-lite'
import {
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCardFooter,
  MDBIcon,
} from 'mdbreact'
import PaymentMethodForm from './../../../../components/Stripe/PaymentMethodForm/PaymentMethodForm.component'
import SubscriptionsStore from './../../Subscriptions.store'

import './PaymentMethods.scss'

const PaymentMethods = () => {
  const {
    isFetching,
    customerId,
    paymentMethods,
    fetchCustomer,
    deletePaymentMethod,
    setDefaultPaymentMethod,
  } = SubscriptionsStore

  const renderNoPayments = () => {
    return (
      <div className="no-methods">
        You have no payment methods on record.
        <br />
        <small>
          Note: Not all users have their payment method on our automated system.
          You may enter it now, or contact Broker Support for additional
          details.
        </small>
      </div>
    )
  }

  const renderPaymentList = () => {
    if (!paymentMethods) return <>Loading Account ...</>

    if (!paymentMethods.length) return renderNoPayments()

    return (
      <table>
        <thead>
          <tr>
            <th>Card Type</th>
            <th>Card Last Four:</th>
            <th>Card Exp:</th>
            <th className="action">
              <small>Default</small>
            </th>
            <th className="action">
              <small>Delete</small>
            </th>
          </tr>
        </thead>
        <tbody>
          {paymentMethods.map((pm) => {
            return (
              <tr key={pm.id} className={pm.default ? 'default-method' : ''}>
                <td>
                  {pm.card.brand.charAt(0).toUpperCase() +
                    pm.card.brand.toLowerCase().substring(1)}
                  {pm.default ? '*' : ''}
                </td>
                <td>{pm.card.last4}</td>
                <td>{pm.card.exp_month + '/' + pm.card.exp_year}</td>
                <td className="action">
                  {pm.default ? (
                    <MDBIcon icon="check" />
                  ) : (
                    <button
                      className="default-btn"
                      disabled={
                        pm.default ||
                        isFetching ||
                        !paymentMethods ||
                        paymentMethods.length < 2
                      }
                      onClick={() => setDefaultPaymentMethod(pm.id)}
                    >
                      <MDBIcon icon="dollar-sign" />
                    </button>
                  )}
                </td>
                <td className="action">
                  {pm.default ? (
                    <></>
                  ) : (
                    <button
                      className="delete-btn"
                      disabled={
                        pm.default ||
                        isFetching ||
                        !paymentMethods ||
                        paymentMethods.length < 2
                      }
                      onClick={() => deletePaymentMethod(pm.id)}
                    >
                      <MDBIcon icon="trash-alt" />
                    </button>
                  )}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }

  const renderPaymentForm = () => {
    if (!customerId) return <></>

    const { User } = SubscriptionsStore

    if (!User?.id()) return <></>

    return (
      <>
        <h6>Update Payment Method:</h6>
        <PaymentMethodForm
          formType={'SaveCard'}
          userId={User.id()}
          customerId={customerId}
          onSuccess={() => fetchCustomer()}
        />
      </>
    )
  }

  return (
    <MDBCard id="PaymentMethodsComponent">
      <MDBCardHeader>Account Billing for {customerId}</MDBCardHeader>
      <MDBCardBody className="payment-method">
        <h6>Payment Methods:</h6>
        {renderPaymentList()}
        <br />
        {renderPaymentForm()}
      </MDBCardBody>
      <MDBCardFooter></MDBCardFooter>
    </MDBCard>
  )
}

export default observer(PaymentMethods)
